import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PlusOutlinedStandard.js";
import l from "../components/PfIcon.js";
const t = (r, e) => {
  const a = {
    ...r,
    ...e.attrs
  };
  return n(l, o(a, {
    icon: d
  }), null);
};
t.displayName = "PlusOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
